export interface HierarchyLink {
  to: string;
  search?: Record<string, string>;
}
export function campaignListLink(agencyId?: string): HierarchyLink {
  return {
    to: agencyId
      ? `/a/${encodeURIComponent(agencyId)}/campaigns/campaigns`
      : '/campaigns/campaigns',
    search: {},
  };
}
export function agencyDetailsLink(id: string, workspaceAgencyId?: string): HierarchyLink {
  return {
    to: workspaceAgencyId
      ? `/a/${encodeURIComponent(workspaceAgencyId)}/campaigns/overview`
      : `/campaigns/agencies/${encodeURIComponent(id)}/details`,
    search: {},
  };
}
export function brandDetailsLink(id: string, agencyId?: string): HierarchyLink {
  return {
    to: `${agencyId ? `/a/${encodeURIComponent(agencyId)}` : ''}/campaigns/brands/${encodeURIComponent(id)}/details`,
    search: {},
  };
}
export function campaignDetailsLink(id: string, agencyId?: string): HierarchyLink {
  return agencyId
    ? { ...campaignListLink(agencyId), search: { campaign: id } }
    : { to: `/campaigns/campaigns/overview/${encodeURIComponent(id)}`, search: {} };
}
